import { post } from '@/utils/request'
// 青少年模式申诉
export const appealPage = function (data) {
    return post({
        url: "/phpapi/youngPerson/appealPage",
        data
    })
}